import Dictionary from "@/types/Dictionary";
import { RegistrationState } from "./RegistrationState";
import { API_URL } from "@/App.settings";
import axios from "axios";
import { RegStateRedirect } from "./RegStateRedirect";

/** Etat : Traitement de la soumission du formulaire */
export class RegStateValidate extends RegistrationState{
    private isValidate = false;
    private isExpired = false;

    public async Next(): Promise<void> {
        if(this.context.Password && this.context.Password.length > 0)
        {
            await this.context.$store.dispatch("ShowLoadingMask", this.context.$t('LoadingRegisterInformation'));

            /** Le token est crypté, il doit être décrypté par le serveur */
            let args: Dictionary<any> = {
                registrationToken: this.token,
                password: this.context.Password
            };

            /** Effectue une vérification du token et une initialisation du formulaire */
            await axios.post(API_URL + "User/RegistrationApply", args).then(async (response) => {
                if(response && response.data)
                {
                    this.context.$bvToast.toast(this.context.ValidateSuccessMessage , { 
                        title: this.context.ValidateTitle,
                        autoHideDelay: 10000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }else{
                    this.isExpired = true;
                    this.context.$bvToast.toast(this.context.ValidateFailMessage, { 
                        title: this.context.ValidateTitle,
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }
                this.isValidate = true;
            }).catch((err) =>{
                console.log(err);
                this.context.$bvToast.toast(this.context.$t('AnErrorOccured').toString(), { 
                    title: this.context.ValidateTitle,
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }).finally(async () => {
                await this.context.$store.dispatch("HideLoadingMask", {});


                /** Redirge si la validation est terminé (success ou expriré) */
                if(this.isValidate){
                    if(this.isExpired)
                        await this.context.$store.dispatch("ShowLoadingMask", this.context.ValidateFailMessage);
                    else
                        await this.context.$store.dispatch("ShowLoadingMask", this.context.ValidateSuccessMessage);
                    this.context.TransitionTo(new RegStateRedirect(this))
                    this.context.Next();
                }
            })
        }
    }
}